// dessins/index.jsx — un dessin par FORME DE RÉPONSE, et rien d'autre.
//
// Les formes viennent de lib/vues-registre.js (FORMES) — six de réponse sur
// le parc, deux sur l'opérateur lui-même (journal, consignes). Ce sont des
// formes de réponse, pas des types de graphique : chaque composant apprend ce
// que le champ `apprend` du registre annonce, ou il ne se rend pas.
//
// Signature commune : ({ titre, donnees }) → le dessin, ou une phrase
// d'absence si les données ne permettent pas de montrer quelque chose d'honnête.
// La forme des données est documentée en tête de chaque composant.

import Evolution from "./Evolution";
import Ecart from "./Ecart";
import Classement from "./Classement";
import Superposition from "./Superposition";
import Repartition from "./Repartition";
import Jours from "./Jours";
import Journal from "./Journal";
import Consignes from "./Consignes";

const DESSINS = Object.freeze({
  evolution: Evolution,
  ecart: Ecart,
  classement: Classement,
  superposition: Superposition,
  repartition: Repartition,
  jours: Jours,
  // Ce qui est À LUI (2026-09-13) : son journal, ses consignes.
  journal: Journal,
  consignes: Consignes,
});

/**
 * Le composant qui dessine une forme, ou null si la forme n'existe pas.
 * ⚠️ Liste FERMÉE : une forme inconnue ne tombe jamais sur un dessin « par défaut ».
 */
export function dessinPourForme(forme) {
  if (typeof forme !== "string") return null;
  return Object.prototype.hasOwnProperty.call(DESSINS, forme)
    ? DESSINS[forme]
    : null;
}

/** Les formes dessinables, pour les tests de couverture contre le registre. */
export function formesDessinables() {
  return Object.keys(DESSINS);
}

export {
  Evolution,
  Ecart,
  Classement,
  Superposition,
  Repartition,
  Jours,
  Journal,
  Consignes,
};
